import { Col, Form, Row, Select } from "antd";
import React from "react";
import { Utilitaries } from "../../../../business";
const { Option } = Select;

export function PlataformConfiguration({ getFieldDecorator, lingua, listLingua, setLingua }) {
    return (
        <Form layout="vertical">
            <Row gutter={16}>
                <Col xs={24} md={8}>
                    <Form.Item label="Língua">
                        {getFieldDecorator("lingua", {
                            initialValue: lingua,
                        })(
                            <Select
                                showSearch
                                allowClear
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                onChange={(_lingua) => setLingua(_lingua)}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {listLingua !== undefined &&
                                    Utilitaries.toArray(listLingua).map((item) => {
                                        return (
                                            <Option key={item.sigla} value={item.sigla}>
                                                {item.designacao}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}
